export const SET_QUESTIONS = 'SET_QUESTIONS'
export const ADD_ANSWER = 'ADD_ANSWER'
export const NEXT_QUSTION = 'NEXT_QUSTION'
export const REPEAT_EXAM = 'REPEAT_EXAM'
export const SET_STEP = 'SET_STEP'
export const SET_RESULT = 'SET_RESULT'
export const SET_COUNT = 'SET_COUNT'
export const RESET = 'RESET'
